const TrashIcon = () => {
  return (
    <div
      style={{
        width: "26px",
        height: "26px",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 12 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.793719 12.6995C0.793719 13.5726 1.50807 14.2869 2.38116 14.2869H8.73091C9.604 14.2869 10.3184 13.5726 10.3184 12.6995V3.17488H0.793719V12.6995ZM2.38116 4.76232H8.73091V12.6995H2.38116V4.76232ZM8.33405 0.793719L7.54033 0H3.57174L2.77802 0.793719H0V2.38116H11.1121V0.793719H8.33405Z"
          fill="#4F5E74"
        />
      </svg>
    </div>
  );
};

const EyeIcon = ({ show }) => {
  if (show)
    return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.6058 12.833C21.501 14.8435 18.0534 20.0549 12.0001 20.0549C5.94677 20.0549 2.49915 14.8435 1.39435 12.833C1.12571 12.3442 1.12571 11.7656 1.39435 11.2768C2.49915 9.26628 5.94677 4.05487 12.0001 4.05487C18.0534 4.05487 21.501 9.26629 22.6058 11.2768C22.8745 11.7656 22.8745 12.3442 22.6058 12.833ZM15.5001 12.0549C15.5001 13.9879 13.9331 15.5549 12.0001 15.5549C10.0671 15.5549 8.5001 13.9879 8.5001 12.0549C8.5001 10.1219 10.0671 8.55487 12.0001 8.55487C13.9331 8.55487 15.5001 10.1219 15.5001 12.0549Z"
          fill="#C1C5CF"
        />
      </svg>
    );
  else
    return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.41431 3.05492C3.02379 2.66439 2.39062 2.66439 2.0001 3.05492C1.60958 3.44544 1.60958 4.0786 2.0001 4.46913L4.63205 7.10108C2.99403 8.61038 1.92448 10.3121 1.39435 11.2768C1.12571 11.7657 1.12571 12.3442 1.39435 12.8331C2.49915 14.8435 5.94677 20.0549 12.0001 20.0549C13.7147 20.0549 15.2203 19.6368 16.5227 18.9918L19.5859 22.0549C19.9764 22.4455 20.6096 22.4455 21.0001 22.0549C21.3906 21.6644 21.3906 21.0312 21.0001 20.6407L3.41431 3.05492ZM8.5001 12.0549C8.5001 11.7242 8.54598 11.4041 8.63173 11.1008L12.9542 15.4233C12.6509 15.5091 12.3309 15.5549 12.0001 15.5549C10.0671 15.5549 8.5001 13.9879 8.5001 12.0549Z"
          fill="#C1C5CF"
        />
        <path
          d="M15.4914 12.3035C15.4972 12.2214 15.5001 12.1385 15.5001 12.0549C15.5001 10.1219 13.9331 8.55492 12.0001 8.55492C11.9165 8.55492 11.8336 8.55785 11.7515 8.56361L8.04521 4.85733C9.21217 4.36262 10.5292 4.05493 12.0001 4.05493C18.0534 4.05493 21.501 9.26634 22.6058 11.2768C22.8745 11.7657 22.8745 12.3442 22.6058 12.8331C22.1228 13.7121 21.1918 15.2032 19.7909 16.603L15.4914 12.3035Z"
          fill="#C1C5CF"
        />
      </svg>
    );
};

export { TrashIcon, EyeIcon, };